module.exports = __webpack_public_path__ + "img/help-square.47afbaba.svg";